export const isAndroidRegx = /Android/i;
export const isIOSRegx = /iPad|iPhone|iPod/i;
export const isMACRegx = /macintosh|mac os x/i;
export const isWINRegx = /w(i|o)(w|n)(32|64)/i;
export const isWeiBoRegx = /WeiBo/i;
export const isMobileRegx = /mobile/i;
export const isWechatRegx = /micromessenger/i;
export const isWxMiniProgramRegx = /miniProgram/i;
export const isDZHRegx = /dzhapp/i;
export const isSafari = /Safari/i;
export const isChrome = /Chrome/i;

export const isHstSDKRegx = /HST_SDK\/1/i;

// 下面两个都是判断同花顺
export const isTHSHexinGphoneRegx = /Hexin_Gphone/i;
export const isTHSIHexinRegx = /IHexin/i;

// 暗黑模式
export const isDarkThemeRegx = /theme\/dark/i;

// 判断是否是QQ
export const isQQRegx = /qq\//i;

// 判读是否是钉钉
export const isDingTalkRegx = /dingtalk\//i;
